module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="pixlee_lb_video_container_box">\n	<video id="example_video_1" class="video-js vjs-default-skin" controls preload="auto" width="auto" height="auto" poster="' +
((__t = ( thumbnail_url )) == null ? '' : __t) +
'">\n	<source src="' +
((__t = ( source_url )) == null ? '' : __t) +
'" type=\'video/mp4\' />\n	</video>\n</div>';

}
return __p
}